<i18n src="@/locales/models/order.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('')"
    :params="{ service_provider_id: service_provider_id }"
  >
  </go-back-link>

  <bread-crumbs :labels="[module_name, delivery_process.name]" />

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :service_provider_id="service_provider_id"
      :delivery_process_id="delivery_process_id"
      :delivery_attributes="delivery_process.delivery_process_attributes.filter(attr => attr.use_in_deliveries)"
      :collection_attributes="delivery_process.delivery_process_attributes.filter(attr => attr.use_in_collections)"
    >
    </router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/show_process.js";

export default {
  name: "SPDeliveryManagingShowProcess",
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
  },
  data() {
    return {
      load_data_general: false,
      delivery_process: {},
      option_tabs: [],
    };
  },
  methods: {
    loadData: async function () {
      this.fillOptionTabs();
      await this.fetchDeliveryProcess();
      this.load_data_general = true;
    },
    fetchDeliveryProcess: async function () {
      let response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );
      this.delivery_process = response.data;
    },
    fillOptionTabs: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.delivery_products_title"),
          icon: "fa fa-box",
          route: { name: this.routeName('show_process_delivery_products') }
        },
        {
          name: this.$t("labels.delivery_process_providers_title"),
          icon: "fa fa-users",
          route: { name: this.routeName('show_process_delivery_process_providers') }
        },
        {
          name: this.$t("labels.delivery_collections_title"),
          icon: "fa fa-box",
          route: { name: this.routeName('show_process_delivery_collections') }
        },
        {
          name: this.$t("labels.orders_title"),
          icon: "fa fa-shopping-cart",
          route: { name: this.routeName('show_process_orders') }
        },
        {
          name: this.$t("labels.deliveries_title"),
          icon: "fa fa-truck",
          route: { name: this.routeName('show_process_deliveries') }
        },
      ];
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
};
</script>
